
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { uiStore } from "@/store/store";
import { getActiveElementPositionAndSize } from "@/lib/canvas/helpers";
import {
  DragHandleBehavior,
  makeDragCallback,
  MouseDragInfo,
  DragCallback
} from "@/lib/canvas/drag/drag";
import { forceNextTick } from "@/util/force-next-tick";
import { EasyEvent, isCanvasEvent } from "@/util/easy-event";

const imageDragHandleBehavior: DragHandleBehavior = {
  xProperty:
    "design.size.width.%%CURRENTMEDIAQUERY%%" /* i'd like it better without the mediaquery thing */
  //   yProperty:
  //     "design.size.width.%%CURRENTMEDIAQUERY%%" /* how do we enforce this is a path to a valid control of type unit input? */
};

@Component({})
export default class NodeChrome extends Vue {
  mouseDragInfo: MouseDragInfo = false;

  dragDotsWrapperPositionStyle: { [key: string]: string } = {
    display: "none"
  };

  dragCallback: false | DragCallback = false;

  unsubscribeFromStorePositionDotsWrapper = () => {};
  nextTickPositionDragDotsWrapper() {
    forceNextTick(() => this.positionDragDotsWrapper());
  }
  beforeMount() {
    this.positionDragDotsWrapper();

    this.unsubscribeFromStorePositionDotsWrapper = this.$store.subscribe(
      this.nextTickPositionDragDotsWrapper
    );

    window.addEventListener("resize", this.nextTickPositionDragDotsWrapper);
  }

  beforeDestroy() {
    this.unsubscribeFromStorePositionDotsWrapper();
    window.removeEventListener("resize", this.nextTickPositionDragDotsWrapper);
  }

  easyEvent = new EasyEvent();

  dragStart(e: MouseEvent) {
    e.preventDefault();
    e.stopPropagation();

    this.mouseDragInfo = {
      startX: e.clientX,
      startY: e.clientY,
      currentX: e.clientX,
      currentY: e.clientY,
      lastXChange: 0,
      lastYChange: 0,
      totalXChange: 0,
      totalYChange: 0
    };

    this.dragCallback = makeDragCallback(imageDragHandleBehavior);

    this.easyEvent.on("mousemove", this.dragging);
    this.easyEvent.on("mouseup", this.dragEnd);
  }

  dragging(e: MouseEvent) {
    if (isCanvasEvent(e)) {
      e.preventDefault();
      e.stopPropagation();

      const elementPositionAndSize = getActiveElementPositionAndSize();
      if (!elementPositionAndSize || !this.mouseDragInfo) return;

      this.mouseDragInfo = {
        ...this.mouseDragInfo,
        currentX: e.clientX,
        currentY: e.clientY,
        lastXChange: e.clientX - this.mouseDragInfo.currentX,
        lastYChange: e.clientY - this.mouseDragInfo.currentY,
        totalXChange: e.clientX - this.mouseDragInfo.startX,
        totalYChange: e.clientY - this.mouseDragInfo.startY
      };

      if (this.dragCallback) {
        this.dragCallback(elementPositionAndSize, this.mouseDragInfo);
      }

      this.positionDragDotsWrapper();
    }
  }

  dragEnd(e: MouseEvent) {
    e.preventDefault();
    e.stopPropagation();

    this.easyEvent.removeAll();

    this.mouseDragInfo = false;
    this.dragCallback = false;
  }

  positionDragDotsWrapper() {
    if (!uiStore.activeElementId) {
      this.dragDotsWrapperPositionStyle = {
        display: "none"
      };
    }

    const elementPositionAndSize = getActiveElementPositionAndSize();
    if (!elementPositionAndSize) return;

    const { x, y, width, height } = elementPositionAndSize;

    this.dragDotsWrapperPositionStyle = {
      position:
        "absolute" /* this won't work if something other than the window has position relative on it 
        maybe we could mount the overlaid ui chrome inside the body */,
      top: y.toString() + "px",
      left: x.toString() + "px",
      width: width.toString() + "px",
      height: height.toString() + "px"
    };
  }
}
